import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'
import { Subscription } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { Source } from 'app/models/source.enum'
import { CompetitionService } from 'app/services/competition.service'
import { Competition } from 'app/models/competition'
import { GuideComponent } from 'app/shared/components/guide/guide.component'
import { SharepointService } from 'app/services/sharepoint.service'
import { SharepointData } from 'app/models/sharepoint-data'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: []
})
export class HomeComponent implements OnInit, OnDestroy {
  competition: Competition
  date: Date = new Date()
  bsModalRef: BsModalRef
  transitionReady: boolean
  footerImageSrc: string
  private footerImageCompetitionId: string
  private routerSub = Subscription.EMPTY
  private competitionSub = Subscription.EMPTY
  private footerImageSub = Subscription.EMPTY
  @Output('imgUrl') imgUrl = new EventEmitter()

  constructor(
    private modalService: BsModalService,
    private competitionService: CompetitionService,
    private sharepointService: SharepointService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => event)
    ).subscribe((val) => {
        this.competition = this.competitionService.getCompetitionSelected()
        this.loadFooterImage()
        this.loginActions()
        this.activateTransition()
      })
  }

  ngOnInit() {
    // Load competition on page refresh
    this.competition = this.competitionService.getCompetitionSelected()
    if (!this.competition) {
      this.competitionSub = this.competitionService.getCompetitionSelectedSubscriber()
        .subscribe((assetBackground) => {
          if (assetBackground) {
            this.competition = this.competitionService.getCompetitionSelected()
            this.loadFooterImage()
            this.activateTransition()
          }
        })
    } else {
      this.loadFooterImage()
      this.activateTransition()
    }
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe()
    this.competitionSub.unsubscribe()
    this.footerImageSub.unsubscribe()
    this.clearFooterImage()
  }

  private loadFooterImage(): void {
    const competition = this.competition
    const competitionId = competition && competition.has_footer_image && competition.assetFooterImage ? competition.id : null
    if (competitionId === this.footerImageCompetitionId) {
      return
    }
    this.footerImageSub.unsubscribe()
    this.clearFooterImage()
    this.footerImageCompetitionId = competitionId
    if (!competitionId) {
      return
    }
    const sharePointFile: SharepointData = Object.assign({}, competition.assetFooterImage, {
      fileName: 'footer',
      mimeType: 'image/*',
    })
    this.footerImageSub = this.sharepointService.downSharepointFile(sharePointFile)
      .subscribe(
        file => this.footerImageSrc = URL.createObjectURL(file.content),
        err => console.log('Unable to load footer image', err)
      )
  }

  private clearFooterImage(): void {
    if (this.footerImageSrc) {
      URL.revokeObjectURL(this.footerImageSrc)
    }
    this.footerImageSrc = null
  }

  private loginActions() {
    if (sessionStorage.getItem('first-start') === 'true') {
      sessionStorage.removeItem('first-start')
      this.openGuide()
    }
  }

  requestFile(fileSortingType, source: Source) {
    // should request resouces from server
    console.log(fileSortingType)
  }

  openGuide() {
    this.bsModalRef = this.modalService.show(GuideComponent, {
      class: 'gray modal-lg',
      backdrop: 'static'
    })
  }

  // TODO workaround to make the animation till the service is actived.
  activateTransition(): void {
    setTimeout(res => {
      this.transitionReady = true
    }, 200)
  }
}
